<script setup lang="ts">

import { AppInput } from '@shared/ui/inputs'
import { BtnPrimary } from '@shared/ui/buttons'

import { useFiltersTeams } from '../../model/teams/filters-teams.hook'

defineOptions({
  name: 'FiltersTeams',
})

const {
  refSearch,
  canManage,
  isLoading,
  openCreateModal,
} = useFiltersTeams()
</script>

<template>
  <div class="filters-teams">
    <AppInput
      v-model="refSearch"
      label="Search"
      placeholder="Team name"
    />

    <BtnPrimary
      v-if="canManage"
      text="Create team"
      color="emerald"
      element-width="auto"
      :disabled="isLoading"
      @click="openCreateModal"
    />
  </div>
</template>

<style scoped lang="scss" src="./FiltersTeams.scss" />
